module.exports = __webpack_public_path__ + "img/charging-hub-suggestion-private.87be5053.svg";